module.exports = __webpack_public_path__ + "media/park_front.4cd3186b.svg";